import React from 'react';
import { Modal } from '../../components';

type RejectSellerOrderModalProps = {
  open: boolean;
  onClose: () => void;
  onReject: () => void;
  updating: boolean;
};

export const RejectSellerOrderModal: React.FC<RejectSellerOrderModalProps> = ({
  open,
  onClose,
  onReject,
  updating,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    // Sentence case and a question, like every other confirmation in the app
    // — "Archive this product?" — rather than Title Case naming the action
    // that has already been named by the button that opened it.
    title="Reject this order?"
    icon="warning"
    primaryAction={{
      label: 'Reject order',
      variant: 'destructive',
      disabled: updating,
      loading: updating,
      onClick: onReject,
    }}
    secondaryActions={!updating ? [
      {
        label: 'Close',
        variant: 'outline',
        onClick: onClose,
      },
    ] : []}
  >
    <p>Confirm you will not be fulfilling this order and the customer will be refunded.</p>
    <br />
    <p className='text-foreground'> Do you want to reject this order?</p>
  </Modal>
);

